import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { useToast } from "@/hooks/use-toast";

function readE2EToastDuration(): number | undefined {
  if (typeof window === "undefined") return undefined;
  const value = (window as Window & { __OCTA_E2E_TOAST_DURATION_MS?: number }).__OCTA_E2E_TOAST_DURATION_MS;
  return typeof value === "number" && value > 0 ? value : undefined;
}

export function Toaster() {
  const { toasts } = useToast();
  const e2eDuration = readE2EToastDuration();
  const durationProps = e2eDuration !== undefined ? { duration: e2eDuration } : {};

  return (
    <ToastProvider {...durationProps}>
      {toasts.map(function({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
